import * as Yup from 'yup'
import { imageInputSchema } from './common'

const validationSchema = Yup.object({
  name: Yup.string().required('Lab Test Category is required'),
  image: imageInputSchema,
})

const sampleTypeValidationSchema = Yup.object({
  name: Yup.string().required('Sample Type is required'),
})

export default {
  validationSchema,
  sampleTypeValidationSchema,
}
